import { render, staticRenderFns } from "./shops-map-layout.vue?vue&type=template&id=0ee35c31&scoped=true"
import script from "./shops-map-layout.vue?vue&type=script&lang=js"
export * from "./shops-map-layout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee35c31",
  null
  
)

export default component.exports